module.exports = __webpack_public_path__ + "img/1547667494.c6ab4eea.jpg";